import {z} from 'zod';

export type DeleteServiceOrderItemsApiResponse = unknown;
export type DeleteServiceOrderItemsApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    items: ({
      serviceJobId: string;
      serviceItemId: string;
    } | null)[];
  } | null;
};
export type PostServiceOrderCalculatePriceBulkApiResponse = void;
export type PostServiceOrderCalculatePriceBulkApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    serviceItems: ({
      /** UUID */
      serviceJobId: string;
      /** UUID */
      serviceItemId: string;
    } | null)[];
  } | null;
};
export type GetOrderItemsTotalAmountApiResponse =
  | /** status 200 Standard response */ ({
      success: boolean | null;
      timestamp: string | null;
      message?: string | null;
      validationErrors?: ({
        message?: string | null;
        field?: string | null;
      } | null)[];
      discount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        vat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetOrderItemsTotalAmountApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type GetServiceOrderApiResponse =
  | /** status 200 Standard response */ ({
      id: string;
      serviceCaseId?: string | null;
      serviceOrderVariantId?: string | null;
      number?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'INVOICED'
        | 'CLOSED'
        | 'LOCKED'
        | 'CORRECTING_FULLY'
        | 'CORRECTING_PARTIALLY'
        | null;
      timeTrackingState?: string | null;
      claimState?: string | null;
      name?: string | null;
      description?: string | null;
      completionAt?: string | null;
      cancelledAt?: string | null;
      closedAt?: string | null;
      recipientId?: string | null;
      technicanId?: string | null;
      mileage?: number | null;
      fuelTank?: number | null;
      batteryCharge?: number | null;
      isCheckoutEnabled?: boolean | null;
      serviceCenterId?: string | null;
      serviceOrderGroupId?: string | null;
      cancelReason?: string | null;
      hasItems?: boolean | null;
      fastTrackIsCompleted?: boolean | null;
      partsMovements?: {
        serviceOrderIssueCompleted?: boolean | null;
        serviceOrderReturnsCompleted?: boolean | null;
        fastTrackIssuesCompleted?: boolean | null;
      } | null;
      serviceItems?: {
        itemsCount: number;
        fullyReturnedItemsCount: number;
        marginUnderMinimumCount?: number | null;
      } | null;
      totalPrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPriceBeforeDiscount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPriceEstimated?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      totalDiscount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      deposit?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      workTime?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      workTimeReal?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      workTimeEstimated?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      paymentInfo?: {
        method?: string | null;
      } | null;
      note?: string | null;
      contactInformation?: {
        id?: string | null;
        contactId?: string | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: {
          countryCode?: string | null;
          prefix?: string | null;
          number?: string | null;
        } | null;
        identityCard?: string | null;
      } | null;
      billingInformation?: {
        customerInformation?: {
          customerId: string;
        } | null;
        contractInformation?: {
          contractId: string;
          legalForm?: string | null;
          name?: string | null;
        } | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type GetServiceOrderCommercialApiResponse =
  | /** status 200 Standard response */ ({
      approvalNumber?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderCommercialApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderCommercialApiResponse =
  | /** status 200 Standard response */ ({
      approvalNumber?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderCommercialApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    approvalNumber?: string | null;
    returnUsedParts?: boolean | null;
    consentToTestDrive?: boolean | null;
  } | null;
};
export type GetServiceOrderComplaintApiResponse =
  | /** status 200 Standard response */ ({
      applicationOfTheLaw?: string | null;
      claimSerialNumber?: string | null;
      claimReason?: string | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderComplaintApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderComplaintApiResponse =
  | /** status 200 Standard response */ ({
      applicationOfTheLaw?: string | null;
      claimSerialNumber?: string | null;
      claimReason?: string | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderComplaintApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    applicationOfTheLaw?: string | null;
    claimSerialNumber?: string | null;
    claimReason?: string | null;
    consentToTestDrive?: boolean | null;
  } | null;
};
export type GetServiceOrderContractApiResponse =
  | /** status 200 Standard response */ ({
      provider?: string | null;
      approvalNumber?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderContractApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderContractApiResponse =
  | /** status 200 Standard response */ ({
      provider?: string | null;
      approvalNumber?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderContractApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    provider?: string | null;
    approvalNumber?: string | null;
    returnUsedParts?: boolean | null;
    consentToTestDrive?: boolean | null;
    isDiscountRemove?: boolean | null;
    isDiscountApply?: boolean | null;
  } | null;
};
export type GetServiceOrderInsuranceApiResponse =
  | /** status 200 Standard response */ ({
      insuranceCompany?: string | null;
      insuranceTypeId?: string | null;
      insuranceEventNumber?: string | null;
      insuranceClaimNumber?: string | null;
      initialInspectionPerformed?: boolean | null;
      vatDeducatible?: boolean | null;
      unblockingOfPayment?: boolean | null;
      coverLetter?: boolean | null;
      returnUsedPart?: boolean | null;
      consentsToTestDrive?: boolean | null;
      insuranceClaimOccurrenceAt?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderInsuranceApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderInsuranceApiResponse =
  | /** status 200 Standard response */ ({
      insuranceCompany?: string | null;
      insuranceTypeId?: string | null;
      insuranceEventNumber?: string | null;
      insuranceClaimNumber?: string | null;
      initialInspectionPerformed?: boolean | null;
      vatDeducatible?: boolean | null;
      unblockingOfPayment?: boolean | null;
      coverLetter?: boolean | null;
      returnUsedPart?: boolean | null;
      consentsToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderInsuranceApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    insuranceCompany?: string | null;
    insuranceTypeId?: string | null;
    insuranceEventNumber?: string | null;
    insuranceClaimNumber?: string | null;
    initialInspectionPerformed?: boolean | null;
    vatDeducatible?: boolean | null;
    unblockingOfPayment?: boolean | null;
    coverLetter?: boolean | null;
    returnUsedPart?: boolean | null;
    consentsToTestDrive?: boolean | null;
    isDiscountRemove?: boolean | null;
    isDiscountApply?: boolean | null;
    insuranceClaimOccurrenceAt?: string | null;
  } | null;
};
export type GetServiceOrderInternalApiResponse =
  | /** status 200 Standard response */ ({
      costCenter?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderInternalApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderInternalApiResponse =
  | /** status 200 Standard response */ ({
      costCenter?: string | null;
      returnUsedParts?: boolean | null;
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderInternalApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    costCenter?: string | null;
    returnUsedParts?: boolean | null;
    consentToTestDrive?: boolean | null;
  } | null;
};
export type GetServiceOrderWarrantyApiResponse =
  | /** status 200 Standard response */ ({
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderWarrantyApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PatchServiceOrderWarrantyApiResponse =
  | /** status 200 Standard response */ ({
      consentToTestDrive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderWarrantyApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    consentToTestDrive?: boolean | null;
  } | null;
};
export type PatchServiceOrderApiResponse =
  | /** status 200 Standard response */ ({
      isMileageValid?: boolean | null;
      highestMileage?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    completionAt?: string | null;
    recipientId?: string | null;
    technicanId?: string | null;
    serviceCenterId?: string | null;
    serviceOrderGroupId?: string | null;
    totalPriceEstimated?: number | null;
    workTimeEstimated?: number | null;
    note?: string | null;
    mileage?: number | null;
    fuelTank?: number | null;
    batteryCharge?: number | null;
    paymentInfo?: {
      method?: string | null;
    } | null;
    cancelReason?: string | null;
    contactInformation?: {
      id?: string | null;
      contactId?: string | null;
      name?: string | null;
      email?: string | null;
      phoneNumber?: {
        countryCode?: string | null;
        prefix?: string | null;
        number?: string | null;
      } | null;
      identityCard?: string | null;
    } | null;
  } | null;
};

export type PatchServiceOrderStateApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      serviceCaseId?: string | null;
      serviceOrderVariantId?: string | null;
      number?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'INVOICED'
        | 'CLOSED'
        | 'LOCKED'
        | null;
      name?: string | null;
      description?: string | null;
      completionAt?: string | null;
      recipientId?: string | null;
      technicanId?: string | null;
      totalPriceWithVat?: number | null;
      totalPrice?: number | null;
      totalPriceEstimated?: number | null;
      totalDiscountWithVat?: number | null;
      totalDiscount?: number | null;
      depositWithVat?: number | null;
      deposit?: number | null;
      workTime?: number | null;
      workTimeReal?: number | null;
      workTimeEstimated?: number | null;
      note?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceOrderStateApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    state:
      | (
          | 'ARCHIVED'
          | 'CANCELLED'
          | 'REQUEST'
          | 'OFFER'
          | 'PLANNED'
          | 'OPEN'
          | 'INPROGRESS'
          | 'PAUSED'
          | 'WORKDONE'
          | 'LOCKED'
          | 'CLOSED'
        )
      | null;
  } | null;
};
export type PostServiceOrderApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      serviceCaseId?: string | null;
      serviceOrderVariantId?: string | null;
      number?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'INVOICED'
        | 'CLOSED'
        | 'LOCKED'
        | null;
      name?: string | null;
      description?: string | null;
      completionAt?: string | null;
      recipientId?: string | null;
      technicanId?: string | null;
      totalPrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPriceEstimated?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      totalDiscount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      deposit?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      workTime?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      workTimeReal?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      workTimeEstimated?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      note?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceOrderApiArg = {
  /** UUID */
  serviceCaseId: string;
  body: {
    orderVariantId: string | null;
  } | null;
};
export type PostServiceOrderChangeVariantApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      serviceCaseId?: string | null;
      serviceOrderVariantId?: string | null;
      number?: string | null;
      state?: string | null;
      name?: string | null;
      description?: string | null;
      completionAt?: string | null;
      recipientId?: string | null;
      technicanId?: string | null;
      totalPriceWithVat?: number | null;
      totalPrice?: number | null;
      totalPriceEstimated?: number | null;
      totalDiscountWithVat?: number | null;
      totalDiscount?: number | null;
      depositWithVat?: number | null;
      deposit?: number | null;
      workTime?: number | null;
      workTimeReal?: number | null;
      workTimeEstimated?: number | null;
      note?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceOrderChangeVariantApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  orderVariantId: string;
};
export type PostServiceOrderChangeVariantCheckApiResponse =
  | /** status 200 Standard response */ ({
      isOrderVariantChangeAllowed?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceOrderChangeVariantCheckApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type GetOrderProfitabilityApiResponse =
  | /** status 200 Standard response */ ({
      /** UUID */
      id?: string | null;
      /** UUID */
      serviceCaseId?: string | null;
      totalPrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPriceEstimated?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      basePrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      deposit?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      restForPayment?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchasePrice?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      profitAfterDiscount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      percentageProfitAfterDiscount?: number | null;
      totalVat?: ({
        type?: string | null;
        rate?: string | null;
        amount?: number | null;
        currency?: string | null;
      } | null)[];
      timePlanned?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      timeReal?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      timeTracked?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      timeSold?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      timePlanningEfficiency?: number | null;
      timePerformance?: number | null;
      timePerformanceChronos?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetOrderProfitabilityApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PutServiceOrderIntegrationApiResponse = {
  urlToOpen?: string | null;
};
export type PutServiceOrderIntegrationApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    actionKey: IntegrationActionKey;
  };
};
export type IntegrationCode =
  | 'CHRONOS'
  | 'AUDATEX'
  | 'HYUNDAI_HAP'
  | 'SILVERDAT_MYCLAIM'
  | 'XENTRY-PARTS-JOB'
  | 'DAIMLER-XENTRY-PARTS-JOB'
  | 'XENTRY-OPERATION-TIME'
  | 'TECRMI'
  | 'DAIMLER_CLARA'
  | 'HYUNDAI_AS1Q'
  | 'SAG'
  | 'MAZDA_PORTAL';
export type IntegrationActionKey =
  | 'chronosContractReport'
  | 'chronosContractSend'
  | 'chronosContractResend'
  | 'audatexTaskCalculations'
  | 'audatexTaskSend'
  | 'audatexTaskResend'
  | 'hyundaiHapReceiveRetrieve'
  | 'hyundaiHapReceiveSend'
  | 'hyundaiHapReceiveResend'
  | 'silverdatMyclaimContractSend'
  | 'silverdatMyclaimContractResend'
  | 'silverdatMyclaimContractCalculations'
  | 'xentryPartsJobRetrieve'
  | 'xentryPartsJobSend'
  | 'xentryOperationTimeRetrieve'
  | 'xentryOperationTimeSend'
  | 'tecrmiSend'
  | 'tecrmiGetBasket'
  | 'daimlerClaraClaimSend'
  | 'daimlerClaraClaimDetail'
  | 'daimlerXentryPartsJobSend'
  | 'daimlerXentryPartsJobRetrieve'
  | 'hyundaiAs1qRetrieve'
  | 'hyundaiAs1qSend'
  | 'sagEshopSend'
  | 'sagEshopRetrieve'
  | 'mazdaGepcSend'
  | 'mazdaGepcRetrieve'
  | 'mazdaPreauthSend'
  | 'mazdaPreauthDetail'
  | 'mazdaClaimSend'
  | 'mazdaClaimDetail'
  | 'mazdaChecklistChoose';
export type IntegrationLevel = 'info' | 'warning' | 'error' | 'success';
export type IntegrationAction = {
  key: IntegrationActionKey;
  style: 'hidden' | 'disabled' | 'enable';
  position?: number | null;
};
export type IntegrationExternalStatus =
  | 'PRE_APPROVAL'
  | 'SUBMITTED'
  | 'REOPENED'
  | 'APPEALED'
  | 'PENDING_PAYMENT'
  | 'DRAFT'
  | 'PENDING_APPROVAL'
  | 'PENDING_REVIEW'
  | 'RETURNED'
  | 'INFORMATION_NEEDED'
  | 'REJECTED'
  | 'NOT_CREATED'
  | 'APPROVED'
  | 'PAID'
  | 'CLOSED'
  | 'NEW'
  | 'PENDING'
  | 'SUSPENDED'
  | 'CANCELLED'
  | 'CANCELED'
  | 'ACCEPTED'
  | 'DENIED'
  | 'PPRV_TO_WORK'
  | 'PPRV_RETURNED'
  | 'PPRV_ACCEPTED'
  | 'PPRV_DENIED'
  | 'PPRV_CANCELLED'
  | 'PPRV_SUSPENDED';

export type GetServiceOrderIntegrationsApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type ServiceJobTrackedTime = {
  serviceCaseJobId?: string | null;
  totalTimeTracked?: string | null;
  timeTrackingItems?: ({
    date?: string | null;
    from?: string | null;
    to?: string | null;
    hours?: string | null;
    employeeName?: string | null;
  } | null)[];
} | null;
export type GetServiceOrderTimeTrackingApiResponse =
  | /** status 200 Standard response */ ({
      serviceOrder?: {
        serviceOrderId?: string | null;
        totalTimeTracked?: string | null;
        serviceCaseJobs?: ServiceJobTrackedTime[];
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetServiceOrderTimeTrackingApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceCaseJobId?: string | null;
};
export type GetServiceOrderMandatoryFieldsApiResponse =
  | /** status 200 Standard response */ ({
      mandatoryFields: string[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderMandatoryFieldsApiArg = {
  /** UUID */
  serviceOrderId: string;
  /** Lifecycle stage to resolve the mandatory fields for. Omitted means every stage. */
  event?: ServiceOrderMandatoryFieldEvent;
};
export type PostServiceRequestCopyToServiceOrderApiArg = {
  /** The target service case */
  serviceCaseId: string;
  /** The target service order */
  serviceOrderId: string;
  body: ({
    serviceOrderId: string;
    serviceJobId: string;
  } | null)[];
};
export type PostServiceRequestCopyToServiceOrderApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceItemsLabourSettingsApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceItemsLabourSettingsApiArg = {
  serviceCaseId: string;
  serviceOrderId: string;
  body: {
    items: {
      serviceJobId: string;
      serviceItemId: string;
    }[];
    itemSettings: {
      isMechanic: boolean;
      mechanicId?: string | null;
      isCostCenter: boolean;
      costCenterId?: string | null;
      isDiscount: boolean;
      discountRate?: number | null;
      isVatType: boolean;
      vatType?: string | null;
      isWorkType: boolean;
      workType?: string | null;
      isPurchasePricePerUnit: boolean;
      purchasePricePerUnit?: {
        isPriceWithVat: boolean;
        amount: number;
        currency: string;
      } | null;
      isSellingPricePerUnit: boolean;
      sellingPricePerUnit?: {
        isPriceWithVat: boolean;
        amount: number;
        currency: string;
      } | null;
    };
  } | null;
};
export type PostServiceItemsMaterialPartRequestApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceItemsMaterialPartRequestApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    serviceItems: {
      serviceJobId: string;
      serviceItemId: string;
    }[];
  };
};
export type PostServiceItemsMaterialPartRequestCancellationApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceItemsMaterialPartRequestCancellationApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    serviceItems: {
      serviceJobId: string;
      serviceItemId: string;
    }[];
  };
};
export type PostServiceItemsMaterialPartIssuedApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceItemsMaterialPartIssuedApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    serviceItems: {
      serviceJobId: string;
      serviceItemId: string;
    }[];
    assignMechanic: {
      id: string;
      isDefault: boolean;
      costCenterId?: string | null;
    };
  };
};
export type GetServiceOrderTypesApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      name?: string | null;
      code?: string | null;
      priority?: string | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderTypesApiArg = void;
export type GetServiceOrderCheckoutRestrictionApiResponse =
  /** status 200 Standard response */
  | {
      message: string;
      code: string;
    }[]
  | /** status 204 Standard response */ undefined;
export type GetServiceOrderCheckoutRestrictionApiArg = {
  serviceCaseId: string;
  serviceOrderId: string;
};

export type PostServiceItemsMaterialPartReturnApiResponse =
  /** status 200 Standard response */
  | {
      authorizationProfileId?: string | null;
      serviceOrderId?: string | null;
      serviceOrderReturnId?: string | null;
    }
  | /** status 204 Standard response */ undefined;
export type PostServiceItemsMaterialPartReturnApiArg = {
  serviceCaseId: string;
  serviceOrderId: string;
  body: {
    serviceItems: {
      serviceJobId: string;
      serviceItemId: string;
    }[];
  };
};

/* Already reworked to zod */

const RESOURCE_ID_ENUM = ['SERVICE_ORDER', 'VEHICLE'] as const;
const MANDATORY_FIELD_ENUM = [
  'mileage',
  'costCenter',
  'claimSerialNumber',
  'approvalNumber',
  'fuelTank',
  'batteryCharge',
  'totalPriceEstimated',
  'completionAtDate',
  'provider',
  'insuranceClaimNumber',
  'insuranceEventNumber',
  'insuranceType',
  'insuranceClaimOccurrenceAt',
  'generatingOrderSheet',
  'insuranceCompany',
  'applicationOfTheLaw',
  'serviceCenterId',
  'serviceOrderGroupId',
  'vehicleRegistrationPlate',
  'vehicleVin',
  'vehicleFirstRegistrationOn',
  'vehicleWarrantyDate',
  'vehicleTechnicalInspectionValidUntil',
] as const;
const EVENT_ENUM = ['BEFORE_OPENING', 'BEFORE_CLOSING'] as const;

export type ServiceOrderMandatoryFieldEvent = (typeof EVENT_ENUM)[number];

export const getServiceCaseServiceOrderMissingMandatoryFieldsApiApiResponseItemSchema = z.object({
  resourceId: z.enum(RESOURCE_ID_ENUM),
  mandatoryField: z.enum(MANDATORY_FIELD_ENUM),
});

export const getServiceCaseServiceOrderMissingMandatoryFieldsApiApiResponseSchema = z.union([
  z.array(getServiceCaseServiceOrderMissingMandatoryFieldsApiApiResponseItemSchema.nullable()),
  z.void(),
]);

export const getServiceCaseServiceOrderMissingMandatoryFieldsApiApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  event: z.enum(EVENT_ENUM).optional(),
});

export type GetServiceCaseServiceOrderMissingMandatoryFieldsApiResponseItem = z.infer<
  typeof getServiceCaseServiceOrderMissingMandatoryFieldsApiApiResponseItemSchema
>;
export type GetServiceCaseServiceOrderMissingMandatoryFieldsApiResponse = z.infer<
  typeof getServiceCaseServiceOrderMissingMandatoryFieldsApiApiResponseSchema
>;
export type GetServiceCaseServiceOrderMissingMandatoryFieldsApiArg = z.infer<
  typeof getServiceCaseServiceOrderMissingMandatoryFieldsApiApiArgSchema
>;

export const getServiceCaseServiceOrderMandatoryFieldsV2ApiResponseSchema = z.union([
  z
    .object({
      mandatoryFields: z.array(z.enum(MANDATORY_FIELD_ENUM)),
    })
    .nullable(),
  z.void(),
]);

export const getServiceCaseServiceOrderMandatoryFieldsV2ApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  event: z.enum(EVENT_ENUM).optional(),
});

export type GetServiceCaseServiceOrderMandatoryFieldsV2ApiResponse = z.infer<
  typeof getServiceCaseServiceOrderMandatoryFieldsV2ApiResponseSchema
>;
export type GetServiceCaseServiceOrderMandatoryFieldsV2ApiArg = z.infer<
  typeof getServiceCaseServiceOrderMandatoryFieldsV2ApiArgSchema
>;

const IntegrationSchema = z.object({
  code: z.string().nullish(),
  serviceCode: z.string().nullish(),
  viewDetailsLink: z.string().nullish(),
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
});

const ServiceOrderIntegrationActionSchema = z.object({
  key: z.string().nullish(),
  style: z.string().nullish(),
  position: z.number().nullish(),
});

const ServiceOrderIntegrationExternalStatusSchema = z.object({
  level: z.enum(['info', 'warning', 'error', 'success']).nullish(),
  // The API declares this as a free-form string - every integration reports its own provider
  // status vocabulary. IntegrationExternalStatus lists the codes getExternalStatusLabel translates.
  status: z.string().nullish(),
});

const ServiceOrderIntegrationNotificationSchema = z.object({
  level: z.enum(['info', 'warning', 'error', 'success']).nullish(),
  content: z.string().nullish(),
});

const ServiceOrderIntegrationSchema = z.object({
  integration: IntegrationSchema.nullish(),
  action: z.array(ServiceOrderIntegrationActionSchema).optional(),
  externalStatus: ServiceOrderIntegrationExternalStatusSchema.nullish(),
  notification: ServiceOrderIntegrationNotificationSchema.nullish(),
  position: z.number().nullish(),
});

export type ServiceOrderIntegration = z.infer<typeof ServiceOrderIntegrationSchema>;

export const GetServiceOrderIntegrationsApiResponseSchema = z.object({
  orderIntegration: z.array(ServiceOrderIntegrationSchema).optional(),
});

export type GetServiceOrderIntegrationsApiResponse = z.infer<
  typeof GetServiceOrderIntegrationsApiResponseSchema
>;

export const GetPartMovementsCountApiResponseSchema = z.union([
  z
    .object({
      serviceOrderIssuesCount: z.number().nullish(),
      serviceOrderReturnsCount: z.number().nullish(),
      fastTrackIssuesCount: z.number().nullish(),
    })
    .nullable(),
  z.void(),
]);

export const GetPartMovementsCountApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type GetPartMovementsCountApiResponse = z.infer<
  typeof GetPartMovementsCountApiResponseSchema
>;
export type GetPartMovementsCountApiArg = z.infer<typeof GetPartMovementsCountApiArgSchema>;

export const GetSmallUnitMaterialCustomRecalculationApiResponseSchema = z.union([
  z
    .object({
      isFixedValueEnabled: z.boolean().nullable().optional(),
      isFixedValueWithVat: z.boolean().nullable().optional(),
      fixedValueAmount: z.number().nullable().optional(),
      whatIfAmountWithoutVat: z.number().nullable().optional(),
      whatIfAmountVat: z.number().nullable().optional(),
      whatIfAmountWithVat: z.number().nullable().optional(),
    })
    .nullable(),
  z.void(),
]);

export const GetSmallUnitMaterialCustomRecalculationApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type GetSmallUnitMaterialCustomRecalculationApiResponse = z.infer<
  typeof GetSmallUnitMaterialCustomRecalculationApiResponseSchema
>;
export type GetSmallUnitMaterialCustomRecalculationApiArg = z.infer<
  typeof GetSmallUnitMaterialCustomRecalculationApiArgSchema
>;

export const PatchSmallUnitMaterialCustomRecalculationBodySchema = z
  .object({
    isFixedValueEnabled: z.boolean(),
    isFixedValueWithVat: z.boolean(),
    fixedValueAmount: z.number().nullable().optional(),
  })
  .nullable();

export const PatchSmallUnitMaterialCustomRecalculationApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  body: PatchSmallUnitMaterialCustomRecalculationBodySchema,
});

export type PatchSmallUnitMaterialCustomRecalculationApiResponse = void;
export type PatchSmallUnitMaterialCustomRecalculationApiArg = z.infer<
  typeof PatchSmallUnitMaterialCustomRecalculationApiArgSchema
>;

export const GetMinimumMarginCustomRecalculationApiResponseSchema = z.union([
  z
    .object({
      isCustomEnabled: z.boolean(),
      customMaterialMargin: z.number().nullable().optional(),
      customLabourMargin: z.number().nullable().optional(),
      materialMargin: z.number().nullable().optional(),
      labourMargin: z.number().nullable().optional(),
      serviceOrderVariantMaterialMargin: z.number().nullable().optional(),
      serviceOrderVariantLabourMargin: z.number().nullable().optional(),
      matchesCurrentSettings: z.boolean(),
    })
    .nullable(),
  z.void(),
]);

export const GetMinimumMarginCustomRecalculationApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type GetMinimumMarginCustomRecalculationApiResponse = z.infer<
  typeof GetMinimumMarginCustomRecalculationApiResponseSchema
>;
export type GetMinimumMarginCustomRecalculationApiArg = z.infer<
  typeof GetMinimumMarginCustomRecalculationApiArgSchema
>;

export const PatchMinimumMarginCustomRecalculationBodySchema = z
  .object({
    isCustomEnabled: z.boolean(),
    customMaterialMargin: z.number().nullable().optional(),
    customLabourMargin: z.number().nullable().optional(),
  })
  .nullable();

export const PatchMinimumMarginCustomRecalculationApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  body: PatchMinimumMarginCustomRecalculationBodySchema,
});

export type PatchMinimumMarginCustomRecalculationApiResponse = void;
export type PatchMinimumMarginCustomRecalculationApiArg = z.infer<
  typeof PatchMinimumMarginCustomRecalculationApiArgSchema
>;

export const PatchMinimumMarginCurrentSettingsApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type PatchMinimumMarginCurrentSettingsApiResponse = void;
export type PatchMinimumMarginCurrentSettingsApiArg = z.infer<
  typeof PatchMinimumMarginCurrentSettingsApiArgSchema
>;
